import JsFunction from './JsFunction';

export default class CreateFunction extends JsFunction {
  // keys are the attr and values are the htmls elements

  inputTemplate = (attr, htmlElement) => {
    if (this.returnAttributeType(attr) === 'image') {
      return `['${attr}'] = {
        data: document.querySelector("[annotationname = '${attr}']").getAttribute("data-image-base64") !== null ? document.querySelector("[annotationname = '${attr}']").getAttribute("data-image-base64") : document.querySelector("[annotationname = '${attr}']").src,
        name: document.querySelector("[annotationname = '${attr}']").getAttribute("name")
      };
      `;
    }
    if (this.returnAttributeType(attr) === 'date') {
      return `['${attr}'] = document.querySelector("[annotationname = '${attr}']").${htmlElement}.replace(/(?<day>\\d+)-(?<month>\\d+-)/,'$<month>$<day>-');`;
    }
    if (this.effectingHtmlElements[attr] && this.returnAttributeType(attr) === 'radiobox')
      return `['${attr}'] = document.querySelector("[annotationname = '${attr}']:checked").value;`;
    return `['${attr}'] = document.querySelector("[annotationname = '${attr}']").${htmlElement};`;
  };

  inputArrayTemplate = ({ modelName, attr }) =>
    `${modelName}["${attr}"] = [...document.querySelector("[annotationname = '${attr}']").querySelectorAll("[arrayvalue]")].map(li=> li.getAttribute('arrayvalue'));`;

  nextFunction;

  apiCallPromisified = '';

  entityName = '';

  importModelParameter = [];

  modelNames = [];

  attributeArray = [];

  effectingHtmlElements = {};

  constructor(method, annotations, htmlDom) {
    super(method, annotations);
    this.inputHtmlElement = method.inputHtmlElement || '';
    this.htmlNames = method.entityAttributes || '';
    this.apiCallPromisified = method.apiCallPromisified || '';
    this.entityName = method.entityName || '';
    this.importModelParameter = method.importModelParameter || [];
    this.modelNames = method.modelNames || [];
    this.attributeArray = this.getMapOfEntitiesToAttributes().get(method.entityName) || [];
    this.effectingHtmlElements = this.getTheHtmlElements(this.attributeArray, htmlDom) || {};
  }

  printImportStatement() {
    return this.apiInstance + this.importStatement + this.importModelParameter;
  }

  printFunction() {
    // first add the parameter code
    this.functionality += this.returnParametesFromHtmlElements();
    // second  add the apiCallPromisified
    this.functionality += this.apiCallPromisified;
    // third if it exist the next functionName
    //  this.functionality += this.printNextFunctionCode();
    this.printNextFunctionCode();
    // fourth clear the next template
    super.clearfunctionNextTemplate();
    // console.log(this.functionality);
    return this.functionality;
  }

  printNextFunctionCode() {
    if (this.nextFunction)
      if(this.nextFunction.transitionById === true){
        this.functionality = this.functionality.replace(
          this.functionNextTemplate,
          this.nextFunction.printFunction({ typeId: 'response.body.query._id' })
        );
      }
      else{
        this.functionality = this.functionality.replace(
          this.functionNextTemplate,
          this.nextFunction.printFunction({ typeId: '' })
        );
      }      
  }

  getTheHtmlElements(attributeArray, htmlDom) {
    return attributeArray.reduce((obj, attribute) => {
      const htmlTag =
        htmlDom.querySelector(`[annotationname = '${attribute}']`)?.tagName.toLowerCase() || '';
      const htmlAttr = this.htmlTagsToAttributes.get(htmlTag) || '';
      if (!htmlAttr) return { ...obj };
      return { ...obj, [attribute]: htmlAttr };
    }, {});
  }

  returnParametesFromHtmlElements() {
    let js = '';
    js = this.attributeArray.reduce((acc, attribute) => {
      // TODO: this could be refactored to simplify the if selection
      if (this.effectingHtmlElements[attribute] && !this.isTable(attribute))
        return (
          acc +
          this.modelNames[0] +
          this.inputTemplate(attribute, this.effectingHtmlElements[attribute])
        );
      if (this.effectingHtmlElements[attribute] && this.isTable(attribute))
        return acc + this.inputArrayTemplate({ modelName: this.modelNames[0], attr: attribute });
      return acc;
    }, '');
    return js;
  }
}
